// extracted by mini-css-extract-plugin
module.exports = {"company-card":"TruckingCompanyCard_company-card__9OMKz","desc":"TruckingCompanyCard_desc__Kflxe"};